import React from "react";
import { Link } from "react-router-dom";
import { User, Building2, ArrowRight } from "lucide-react";
import { Card, CardHeader } from "@/components/ui/card";

const ChooseSignup: React.FC = () => (
  <div className="py-12 flex flex-col items-center bg-sauna-beige px-4">
    <div className="max-w-2xl w-full text-center">
      <h2 className="text-3xl font-bold mb-4 text-sauna-navy">Create Your Account</h2>
      <p className="text-sauna-navy/80 mb-8 text-lg">
        Choose your account type to get started with our new multi-step signup process
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <Link to="/signup/guest" className="group">
          <Card className="h-full hover:shadow-xl hover:border-sauna-orange transition-all duration-300 transform hover:-translate-y-1">
            <CardHeader>
              <div className="flex items-center justify-center mb-4">
                <div className="w-16 h-16 bg-sauna-orange/10 rounded-full flex items-center justify-center">
                  <User className="w-8 h-8 text-sauna-orange" />
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-sauna-navy">Register as Guest</h3>
              <p className="text-sauna-navy/70 mb-4">
                Join as a Guest to discover and book sauna experiences
              </p>
              <div className="flex items-center justify-center text-sauna-orange font-medium">
                Get Started <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </div>
            </CardHeader>
          </Card>
        </Link>
        
        <Link to="/signup/operator" className="group">
          <Card className="h-full hover:shadow-xl hover:border-sauna-navy transition-all duration-300 transform hover:-translate-y-1">
            <CardHeader>
              <div className="flex items-center justify-center mb-4">
                <div className="w-16 h-16 bg-sauna-navy/10 rounded-full flex items-center justify-center">
                  <Building2 className="w-8 h-8 text-sauna-navy" />
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-sauna-navy">Register as Operator</h3>
              <p className="text-sauna-navy/70 mb-4">
                List your sauna business and manage bookings
              </p>
              <div className="flex items-center justify-center text-sauna-navy font-medium">
                Get Started <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </div>
            </CardHeader>
          </Card>
        </Link>
      </div>
      
      <div className="bg-sauna-orange/10 p-4 rounded-lg border border-sauna-orange/20">
        <p className="text-sm text-sauna-navy/80 mb-2">
          <strong>New!</strong> Try our enhanced multi-step signup process
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <Link 
            to="/multi-step-signup-demo" 
            className="text-sauna-orange hover:underline font-medium text-sm"
          >
            View Basic Multi-Step Demo →
          </Link>
          <span className="text-sauna-navy/40 text-sm hidden sm:inline">|</span>
          <Link 
            to="/multi-step-signup-with-role-demo" 
            className="text-sauna-orange hover:underline font-medium text-sm"
          >
            View Enhanced Demo with Role Selection →
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default ChooseSignup; 